import React, { FC, Ref } from 'react';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { KocAilemIcon, BaseCheckIcon } from '@assets/icons';
import { ModalApi } from '@components/Modal';
import Input from '@components/Input';
import RadioGroup from '@components/RadioGroup';

import { KocAilemModalSchema } from '../../schemas';
import PromotionModal from '..';
import {
  responsiveness,
  Span,
  Label,
  Content,
  Section,
  Paragraph,
} from './styled';
import { Button } from '../../common/styled';
export interface KocAilemModalFormData {
  type: number;
  number: string;
}

interface KocAilemModalProps {
  modal?: Ref<ModalApi>;
  onSubmit: (formData: KocAilemModalFormData) => void;
  onCancel?: () => void;
  isVisible?: boolean;
  isValidated?: boolean;
}

const Title = (
  <>
    <span>KoçAilem</span>
    <Span>Hesap Doğrulama</Span>
  </>
);

const getLabel = (option: string) => <Label>{option}</Label>;
const getValue = (option: string, index?: number) => `${option}#${index}`;
const getOption = (value: string) => {
  const [, index] = value.split('#');
  return [+index, +index] as [number, number];
};

const options = ['T.C Kimlik No İle Doğrula', 'KoçAilem No İle Doğrula'];
const headerMediaQuery = '@media screen and (max-width: 465px)';

const KocAilem: FC<KocAilemModalProps> = ({
  modal,
  onSubmit,
  onCancel,
  isVisible,
  isValidated = false,
  ...rest
}) => {
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors, isSubmitting },
  } = useForm<KocAilemModalFormData>({
    defaultValues: {
      type: 0,
      number: '',
    },
    resolver: yupResolver(KocAilemModalSchema),
  });

  const label =
    watch('type') === 0 ? 'T.C Kimlik Numaranız' : 'KoçAilem Numaranız';
  const inputType = watch('type') === 0 ? { type: 'number' } : {};

  return (
    <PromotionModal
      modal={modal}
      width={674}
      noPromotionInfo={true}
      titleResponsiveness={responsiveness}
      title={Title}
      headerMediaQuery={headerMediaQuery}
      onCancel={onCancel}
      isVisible={isVisible}
      {...rest}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Content>
          <KocAilemIcon width={100} />
          <Section>
            <Paragraph>
              İndirimli otel odasını seçerek devam etmek için T.C Kimlik
              numaranız veya KoçAilem Kart No ile hesabınızı doğrulayın.
            </Paragraph>
          </Section>
          <Section>
            <Controller
              control={control}
              name='type'
              render={({ field }) => (
                <RadioGroup
                  options={options}
                  direction='column'
                  selectedIndex={0}
                  getLabel={getLabel}
                  getOption={getOption}
                  getValue={getValue}
                  {...field}
                />
              )}
            />
            <Controller
              control={control}
              name='number'
              render={({ field }) => (
                <Input
                  label={label}
                  {...inputType}
                  {...field}
                  hasError={Boolean(errors.number)}
                />
              )}
            />
            <Button
              disabled={isSubmitting}
              outline
              size='large'
              htmlType='submit'
              isValid={isValidated}
            >
              <span>{!isValidated ? 'Doğrula' : 'Doğrulandı'}</span>
              <BaseCheckIcon width={24} height={24} />
            </Button>
          </Section>
        </Content>
      </form>
    </PromotionModal>
  );
};

export default KocAilem;
